import './digital.css';
import React, { Suspense, useEffect } from 'react';

import Loadingpage from '../Loadingpage';

// Styles
import styles from './index.module.sass';

export default function DigitalCatalog({ device }) {
  const digitalCatalog =
    'https://viewer.ipaper.io/terramar-brands/sin-carrito/mx-catalogo-digital/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Suspense fallback={<Loadingpage />}>
      <div className={styles.catalogContainer}>
        <iframe
          title='Terramar Digital Catalog'
          src={digitalCatalog}
          frameborder='0'
          style={{
            width: '100%',
            height: '100%',
          }}
          allow='autoplay; fullscreen;'
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen></iframe>
      </div>
    </Suspense>
  );
}
